import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "gateway-wrapper",
  ondragstart: "return false"
};
const _hoisted_2 = {
  key: 0,
  class: "submit-share-area"
};
const _hoisted_3 = {
  class: "not-pipl-gateway-search"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1);
import { useI18n } from 'vue-i18n';
import { useWindowSize } from '@vueuse/core';
import { useStore } from 'vuex';
import { useRoute, useRouter, onBeforeRouteLeave } from 'vue-router';
import { nextTick, onMounted, ref, shallowRef, onUnmounted, computed, onActivated, onBeforeMount } from 'vue';
import constants, { encryptedMarketplaceId } from '@/constants';
import { API_RESPONSE_STATUS_CODE } from '@/configs/common';
import { useLess } from '@/models/hooks';
import { Bridge } from '@/utils/bridge';
import { getWidgetPopup, getGatewayModulesInfo, getFloatingWindow } from '@/models/api/landingPageApi';
import { getType, getAccessToken, isShowPIPLConfirmAlertView, handleStartLogin, isLoginAuthenticated } from '@/utils/common';
import RecommendedAsins from '@/components/recommendedAsins/RecommendedAsins.vue';
import LoginTooltip from '@/components/popup/LoginTooltip.vue';
import FloatingWindow from '@/views/landingPage/floatingWindow/FloatingWindow.vue';
import SearchWidget from '@/views/landingPage/searchWidget/SearchWidget.vue';
import PopupWidget from '@/views/landingPage/popupWidget/PopupWidget.vue';
import { LANDING_PAGE_PARAMS_PAGE_TYPE } from '@/utils/landingPageCommon.js';
import { SET_AGENT_DATA } from '@/store/mutations.types';
import { handleOpenApp } from '@/views/detailPage/hooks/hooks.js';
import { useRecordLoadingEvent } from '@/models/hooks';
import { loadingEvents } from '@/configs/awsRumConfig';
import { gatewayWidgetComponents, LOGINTOOLTIP_ID } from '@/configs/views/landingPage.js';
import { getDeviceId } from '@/utils/device';
const BACK_TOP_DISTANCE_FROM_BOTTOM = 36;
export default {
  __name: 'Gateway',
  setup(__props) {
    useRecordLoadingEvent(duration => ({
      ...loadingEvents.landingPage.gatewayPage,
      duration
    }));
    useLess('views/gateway/Gateway.less');
    const {
      t
    } = useI18n();
    const floatingData = shallowRef({});
    const {
      ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP,
      ENCRYPTED_MARKETPLACE_ID,
      IMAGE_URL,
      NEW_IMAGE_URL,
      SHARE_MODULE: {
        shareRouter: {
          GATEWAY,
          DETAIL_PAGE
        }
      }
    } = constants;
    const route = useRoute();
    const router = useRouter();
    const isPullRefresh = ref(false); // Dropdown refresh or not
    const isPullRefreshDisabled = ref(true);
    // Full screen component type
    const FULL_SCREEN_COMPONENTS = ['bestseller'];
    // If the type of infinite scrolling component is infinite scrolling, place this component at the end
    const WATERFALL_COMPONENTS = ['dealWidget', 'recommendedAsin'];
    const store = useStore();
    const isShowWidgetComponent = ref(false);
    const isShowLoading = ref(true);
    const RIGHT_ARROW_GREY = `${IMAGE_URL}assets/image/icons/rightArrowGrey.png`;
    const BADGE_LOGO_URL = `${NEW_IMAGE_URL}04_BadgeLogo/Logo_Settings3x.png`;
    const SEARCH_URL = `${IMAGE_URL}assets/svg/dNavSearch.svg`;
    const popupWidgetList = ref([]); // Popup advertising data
    const isLogin = ref(false);
    const isShowLoginToolTip = ref(false);
    const distanceFromTop = computed(() => {
      var _store$state$navigato, _store$state$navigato2;
      return (_store$state$navigato = (_store$state$navigato2 = store.state.navigator.agentData) === null || _store$state$navigato2 === void 0 ? void 0 : _store$state$navigato2.top) !== null && _store$state$navigato !== void 0 ? _store$state$navigato : 0;
    });
    const tabbarHeight = computed(() => {
      var _store$state$common$t;
      return (_store$state$common$t = store.state.common.tabbarHeight) !== null && _store$state$common$t !== void 0 ? _store$state$common$t : 0;
    });
    const isShowFloatingWindow = ref(false);
    const widgetList = ref([]);
    const gatewayPageHeight = ref(0);
    const recommendListRef = ref(null);
    const isNoPiplGatewayLoading = ref(false);
    const loginTooltipHeight = computed(() => {
      var _store$state$common$l, _store$state$common;
      return (_store$state$common$l = (_store$state$common = store.state.common) === null || _store$state$common === void 0 ? void 0 : _store$state$common.loginTooltipHeight) !== null && _store$state$common$l !== void 0 ? _store$state$common$l : 0;
    });
    const isPIPLAuthorized = computed(() => {
      var _store$state$common$i, _store$state$common2;
      return (_store$state$common$i = (_store$state$common2 = store.state.common) === null || _store$state$common2 === void 0 ? void 0 : _store$state$common2.isPIPLAuthorized) !== null && _store$state$common$i !== void 0 ? _store$state$common$i : false;
    });
    const onRecommendListLoading = (status, isNextPage) => {
      isPullRefresh.value = isNextPage;
      if (!isNextPage) {
        isNoPiplGatewayLoading.value = !status;
      }
      isPullRefreshDisabled.value = !status;
    };
    const handleLogin = async () => {
      if (await isShowPIPLConfirmAlertView()) return;
      handleStartLogin();
    };
    const filterComponent = categoryType => {
      var _gatewayWidgetCompone, _gatewayWidgetCompone2;
      return (_gatewayWidgetCompone = gatewayWidgetComponents.filter(componentItem => componentItem.type === categoryType)) === null || _gatewayWidgetCompone === void 0 ? void 0 : (_gatewayWidgetCompone2 = _gatewayWidgetCompone[0]) === null || _gatewayWidgetCompone2 === void 0 ? void 0 : _gatewayWidgetCompone2.component;
    };
    const setComponentPaddingBottom = componentIndex => {
      return componentIndex + 1 === widgetList.value.length && {
        paddingBottom: `${tabbarHeight.value}px`
      };
    };
    const getWidgetPopupInfo = async () => {
      const deviceId = await getDeviceId();
      const params = {
        marketplaceId: encryptedMarketplaceId,
        language: ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP[ENCRYPTED_MARKETPLACE_ID],
        paramType: 0,
        pageType: LANDING_PAGE_PARAMS_PAGE_TYPE.GATEWAY,
        deviceId,
        customerContext: {
          personalRecStatus: true
        }
      };
      const {
        data
      } = await getWidgetPopup(params, await getAccessToken());
      if (data.code === API_RESPONSE_STATUS_CODE.SUCCESS) {
        var _data$data;
        popupWidgetList.value = ((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.list) || [];
        Bridge.callFn('saveDataToMemoryCache', {
          key: 'isGatewayWidgetPopupCalled',
          value: true
        });
      }
    };
    // combineWidgetComponents shelf data
    const combineWidgetComponents = async () => {
      try {
        var _gatewayModulesInfo$d;
        const params = {
          language: ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP[ENCRYPTED_MARKETPLACE_ID],
          pageType: LANDING_PAGE_PARAMS_PAGE_TYPE.HOME_PAGE,
          previewMode: false,
          customerContext: {
            personalRecStatus: true
          }
        };
        const gatewayModulesInfo = await getGatewayModulesInfo(params);
        if ((gatewayModulesInfo === null || gatewayModulesInfo === void 0 ? void 0 : (_gatewayModulesInfo$d = gatewayModulesInfo.data) === null || _gatewayModulesInfo$d === void 0 ? void 0 : _gatewayModulesInfo$d.code) === API_RESPONSE_STATUS_CODE.SUCCESS) {
          widgetList.value = gatewayModulesInfo.data.widgets;
        } else {
          widgetList.value = constants.GATEWAY_MODULE_DEFAULT.WIDGETS;
        }
        isPullRefresh.value = false;
        isPullRefreshDisabled.value = false;
      } catch (error) {
        widgetList.value = constants.GATEWAY_MODULE_DEFAULT.WIDGETS;
        console.error('combineWidgetComponents error>>>', error);
      }
    };
    const getGatewayFloatingWindow = async () => {
      try {
        const params = {
          marketplaceId: ENCRYPTED_MARKETPLACE_ID,
          language: ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP[ENCRYPTED_MARKETPLACE_ID],
          paramType: 0,
          pageType: LANDING_PAGE_PARAMS_PAGE_TYPE.GATEWAY
        };
        const {
          data
        } = await getFloatingWindow(params);
        if (data.code === API_RESPONSE_STATUS_CODE.SUCCESS) {
          floatingData.value = (data === null || data === void 0 ? void 0 : data.data) || {};
        }
      } catch (error) {
        console.error('getFloatingWindow error>>>', error);
      }
    };
    const handlePageClick = e => {
      const id = e.target.id;
      if (id !== LOGINTOOLTIP_ID) {
        e.stopPropagation();
      }
    };
    const onClickOpenApp = () => {
      handleOpenApp(GATEWAY);
    };
    const getWindowSize = async () => {
      await nextTick();
      const {
        height
      } = useWindowSize();
      gatewayPageHeight.value = height.value;
    };
    onBeforeMount(async () => {
      var _route$query;
      if ((_route$query = route.query) !== null && _route$query !== void 0 && _route$query.isShare) {
        isShowLoginToolTip.value = true;
      }
    });
    const onPullRefresh = () => {
      isPullRefresh.value = true;
      isPullRefreshDisabled.value = true;
      if (isShowWidgetComponent.value) {
        combineWidgetComponents();
      } else {
        recommendListRef.value.onPullRefresh();
      }
    };
    onMounted(async () => {
      if (isShowLoginToolTip.value) {
        document.addEventListener('click', handlePageClick, true);
      }
      store.commit(`navigator/${SET_AGENT_DATA}`, {
        top: 0
      });
      isLogin.value = !(await isLoginAuthenticated(false));
      isShowLoading.value = true;
      isShowWidgetComponent.value = !(await isShowPIPLConfirmAlertView(false));
      isShowLoading.value = false;
      getWindowSize();
      if (isShowWidgetComponent.value) {
        Bridge.callFn('getDataFromMemoryCache', {
          key: 'isGatewayWidgetPopupCalled'
        }, res => {
          if (getType(res.value) === 'object' && !isShowLoginToolTip.value) {
            getWidgetPopupInfo();
          }
        });
        getGatewayFloatingWindow();
        combineWidgetComponents();
      }
      Bridge.callFn('onGatewayElementMounted', {}, () => {});
    });
    onActivated(async () => {
      const navDom = document.querySelector('.nav-wrapper');
      nextTick(() => {
        store.commit('navigator/setNavHeight', navDom === null || navDom === void 0 ? void 0 : navDom.clientHeight);
      });
      const componentWrapperDom = document.querySelector('.component-wrapper');
      if (componentWrapperDom) {
        componentWrapperDom.scrollTop = store.state.landingPage.gatewayScrollTop;
      }
    });
    onBeforeRouteLeave(() => {
      const componentWrapperDom = document.querySelector('.component-wrapper');
      if (componentWrapperDom) {
        store.commit(`landingPage/getGatewayScrollTop`, componentWrapperDom.scrollTop);
      }
    });
    onUnmounted(() => {
      store.commit(`navigator/${SET_AGENT_DATA}`);
    });
    return (_ctx, _cache) => {
      const _component_amz_pull_refresh = _resolveComponent("amz-pull-refresh");
      const _component_van_button = _resolveComponent("van-button");
      const _component_back_top = _resolveComponent("back-top");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [isShowWidgetComponent.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(LoginTooltip, {
        isShow: isShowLoginToolTip.value,
        showPageType: _unref(DETAIL_PAGE),
        onHandleLogin: onClickOpenApp
      }, null, 8, ["isShow", "showPageType"]), _createElementVNode("div", {
        class: "component-wrapper",
        style: _normalizeStyle({
          'padding-top': distanceFromTop.value + 'px'
        })
      }, [_createVNode(_component_amz_pull_refresh, {
        isLoad: isPullRefresh.value,
        onOnRefresh: onPullRefresh,
        isDisabled: isPullRefreshDisabled.value
      }, {
        content: _withCtx(() => [widgetList.value.length ? (_openBlock(), _createBlock(SearchWidget, {
          key: 0
        })) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(widgetList.value, (componentItem, componentIndex) => {
          return _openBlock(), _createBlock(_resolveDynamicComponent(filterComponent(componentItem.categoryType)), {
            style: _normalizeStyle(setComponentPaddingBottom(componentIndex)),
            key: componentItem.uuid,
            properties: componentItem
          }, null, 8, ["style", "properties"]);
        }), 128))]),
        _: 1
      }, 8, ["isLoad", "isDisabled"])], 4), isShowLoginToolTip.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_van_button, {
        id: _unref(LOGINTOOLTIP_ID),
        round: "",
        onClick: onClickOpenApp
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('modules.detailPage.GO_APP_VIEW')), 1)]),
        _: 1
      }, 8, ["id"])])) : _createCommentVNode("", true)], 64)) : _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "not-pipl-gateway",
        style: _normalizeStyle({
          paddingTop: distanceFromTop.value + 'px'
        })
      }, [_createElementVNode("div", {
        class: "not-pipl-gateway-logo"
      }, [_createElementVNode("img", {
        src: BADGE_LOGO_URL,
        alt: ""
      })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "gateway-search-box",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).push('/search'))
      }, [_createElementVNode("img", {
        src: SEARCH_URL,
        alt: ""
      }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('modules.detailPage.SEARCH')), 1)])]), _createVNode(_component_amz_pull_refresh, {
        isLoad: isPullRefresh.value,
        onOnRefresh: onPullRefresh,
        isDisabled: isPullRefreshDisabled.value
      }, {
        content: _withCtx(() => [_createVNode(RecommendedAsins, {
          ref_key: "recommendListRef",
          ref: recommendListRef,
          title: _ctx.$t('modules.detailPage.BEST_SELLING_ITEM_RECOMMENDATION'),
          onIsLoading: onRecommendListLoading
        }, {
          loading: _withCtx(() => [_hoisted_4]),
          _: 1
        }, 8, ["title"])]),
        _: 1
      }, 8, ["isLoad", "isDisabled"]), _createVNode(_component_back_top, {
        scrollRef: ".pull-refresh-container",
        bottom: BACK_TOP_DISTANCE_FROM_BOTTOM,
        style: _normalizeStyle({
          marginBottom: tabbarHeight.value + loginTooltipHeight.value + 'px'
        })
      }, null, 8, ["style"])], 4)), [[_directive_loading, isNoPiplGatewayLoading.value]]), isPIPLAuthorized.value ? (_openBlock(), _createBlock(LoginTooltip, {
        key: 2,
        isShow: isLogin.value,
        showPageType: _unref(GATEWAY),
        onHandleLogin: handleLogin,
        style: _normalizeStyle({
          marginBottom: tabbarHeight.value + 'px'
        })
      }, null, 8, ["isShow", "showPageType", "style"])) : _createCommentVNode("", true), _createVNode(FloatingWindow, {
        class: _normalizeClass({
          'floating-window-bottom-wrapper': isShowLoginToolTip.value
        }),
        isFloatingWindowBottom: isShowLoginToolTip.value,
        floatingData: floatingData.value,
        isShowFloatingWindow: isShowFloatingWindow.value,
        offsetTop: gatewayPageHeight.value,
        scrollRef: ".component-wrapper"
      }, null, 8, ["class", "isFloatingWindowBottom", "floatingData", "isShowFloatingWindow", "offsetTop"]), _createVNode(PopupWidget, {
        widgetList: popupWidgetList.value
      }, null, 8, ["widgetList"])])), [[_directive_loading, isShowLoading.value]]);
    };
  }
};